<ng-container *ngIf="working">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="working === false && ready">
    <convfact-ticket-form [ticket]="ticket" [accountsAndTaxes]="accountsAndTaxes" [bankAccounts]="bankAccounts" [contactList]="contactList"
        [errors]="errors" (onSave)="saveData($event)"></convfact-ticket-form>
</ng-container>
<ng-container *ngIf="ready === false">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>